<template>
  <div>
    <div onContextMenu="return(false)" ref="table"></div>
    <button
      type="button"
      class="controls__button controls__button_add_row"
      @click="addRow"
    >
      <base-material-design-icon icon="plus" class="controls__icon" />
      <span>Add Condition</span>
    </button>
    <div class="controls">
      <button
        type="button"
        class="controls__button controls__button_cancel"
        @click="clear"
      >
        Clear Filter
      </button>
      <button
        @click="apply"
        class="controls__button  controls__button_submit"
      >
        Apply
      </button>
    </div>
    <base-material-design-icon style="font-size:14px;" ref="icon" icon="closeCircle" />
  </div>
</template>

<script>

import Tabulator from 'tabulator-tables'
import _ from 'lodash'
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'Filters',
  mixins: [BaseModalMixins],
  props: {
    columns: Array,
    allFilters: Array,
    order: Object,
    getFilterFields: Function,
    fieldLabels: Object,
    isVisible: Boolean
  },
  data () {
    return {
      table: null,
      filter_table_state: {},
      rowId: 0,
      tableData: [],
      rawIconHtmlString: ''
    }
  },
  computed: {
    labelFields () {
      const labelFields = {}
      for (const k in this.fieldLabels) {
        labelFields[this.fieldLabels[k]] = k
      }
      return labelFields
    },
    defaultField () {
      return Object.keys(this.fieldLabels).find(label => this.order[label] === 1)
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async loadData () {
      const _data = {
        modified_field: 'field',
        state: {
          'field': 'keyword'
        }
      }
      let data = await this.getFilterFields({ clientId: this.clientId, data: _data })
      if (data.modified_field === 'field') {
        this.filter_table_state[_data.state.field] = data
      }
    },
    async _cellEdited (cell) {
      const _field = cell._cell.column.field.toLowerCase()
      const _items = {}
      const _cells = cell._cell.row.cells

      for (let i = 0; i < _cells.length; i++) {
        let _key = _cells[i].column.field
        let _val = _cells[i].value
        if (_key === 'field') {
          _val = this.labelFields[_val]
        }
        _items[_key] = _val
      }

      const _data = {
        modified_field: _field,
        state: _items
      }
      let data = await this.getFilterFields({ clientId: this.clientId, data: _data })
      if (data.modified_field === 'field') {
        const rowField = this.labelFields[cell.getRow().getCell('field').getValue()]
        this.filter_table_state[rowField] = data
        cell._cell.row.cells[3].setValue(data.default_operator)
        cell.getRow().getCell('filter_value').setValue('')
      }
    },
    _editorParams (type, scope) {
      return function (cell) {
        const rowField = scope.labelFields[cell.getRow().getCell('field').getValue()]
        if (type === 'operator') {
          return scope.filter_table_state[rowField].operators
        }
        if (type === 'filter_value') {
          return scope.filter_table_state[rowField].field_values
        }

        let fieldLabelsCopy = _.cloneDeep(scope.fieldLabels)

        let _filterFieldsValue = []
        for (const i in fieldLabelsCopy) {
          const index = scope.order[i]
          _filterFieldsValue[index] = {
            'label': fieldLabelsCopy[i],
            'value': i
          }
        }
        return _filterFieldsValue
      }
    },
    addRow () {
      this.rowId += 1
      this.table.addRow({ id: this.rowId, close_button: 1, inclusive: 'include', field: this.defaultField })
        .then(row => {
          const cell = row.getCell('field')
          this._cellEdited(cell)
        })
    },
    clear () {
      this.$emit('clearFilter')
    },
    removeFilter (filter) {
      this.$emit('removeFilter', filter)
    },
    apply () {
      let _filters = this.table.getData()
      let filters = []
      for (let i = 0; i < _filters.length; i++) {
        let current = _filters[i]
        if (!current.inclusive || !current.field || !current.operator || !current.filter_value) {
          continue
        }
        const _filter = {
          field: this.labelFields[current.field],
          type: current.operator,
          value: (current.inclusive === 'exclude' ? '~' : '') + current.filter_value
        }
        filters.push(_filter)
      }
      this.$emit('setFilter', filters)
    },
    handleFilters (newData) {
      const currentFilters = this.table.getData()
      let filters = currentFilters.map(filter => {
        return {
          field: this.labelFields[filter.field],
          type: filter.operator,
          value: (filter.inclusive === 'exclude' ? '~' : '') + filter.filter_value
        }
      })
      let addedFilters = newData.filter(newFilter => !filters.some(currentFilter => _.isEqual(currentFilter, newFilter)))
      const removedFilters = filters.filter(currentFilter => !newData
        .some(newFilter => _.isEqual(newFilter, currentFilter)))
        .filter(filter => filter.field && filter.type && filter.value)

      // this removes rows in the filter table if corresponding filters have been removed
      removedFilters.forEach(obj => {
        const exclusive = obj.value.startsWith('~')
        const value = exclusive ? obj.value.slice(1) : obj.value
        const rowData = {
          inclusive: exclusive ? 'exclude' : 'include',
          field: obj.field[0].toUpperCase() + obj.field.slice(1),
          operator: obj.type,
          filter_value: value
        }
        const matchedRow = this.table.getRows().filter(row => {
          row = row._row.data
          return row.inclusive === rowData.inclusive &&
          row.field === this.fieldLabels[rowData.field.toLowerCase()] &&
          row.operator === rowData.operator &&
          row.filter_value === rowData.filter_value
        })[0]
        this.table.deleteRow(matchedRow)
      })

      addedFilters = addedFilters.reduce((previous, current) => {
        if (current.type === 'in' && Array.isArray(current.value)) { // handle 'in' filters
          for (let i = 0; i < current.value.length; i++) {
            previous.push({
              field: current.field,
              type: 'in',
              value: current.value[i]
            })
          }
        } else {
          previous.push(current)
        }
        return previous
      }, [])

      addedFilters.forEach(obj => {
        let isExclusive = obj.value.startsWith('~')
        this.rowId += 1
        this.table.addRow({
          id: this.rowId,
          close_button: 1,
          inclusive: isExclusive ? 'exclude' : 'include',
          field: obj.field,
          operator: obj.type === 'like' ? 'Containing' : obj.type,
          filter_value: isExclusive ? obj.value.slice(1) : obj.value
        })
      })
    }
  },
  watch: {
    clientId (clientId) {
      this.loadData()
    },
    allFilters (newData) {
      this.handleFilters(newData)
    },
    isVisible (val) {
      if (val && !this.table.getRows().length) {
        this.addRow()
      }
    }
  },
  mounted () {
    if (this.clientId) {
      this.loadData()
    }
    this.rawIconHtmlString = this.$refs.icon.$el.outerHTML.toString()
    this.$refs.icon.$el.parentNode.removeChild(this.$refs.icon.$el)

    const vueComponent = this
    this.table = new Tabulator(this.$refs.table, {
      data: vueComponent.tableData,
      layout: 'fitColumns',
      movableColumns: true,
      headerVisible: false,
      maxHeight: 170,
      columns: [
        {
          title: '',
          field: 'close_button',
          hozAlign: 'center',
          resizable: true,
          headerSort: false,
          minWidth: 50,
          width: 50,
          formatter: function (cell, formatterParams, onRendered) { // plain text value
            return vueComponent.rawIconHtmlString // this provides material-design-icon as raw html
          },
          cellClick: function (e, cell) {
            const data = cell.getData()
            if (data.field && data.operator && data.filter_value) {
              const filter = {
                field: vueComponent.labelFields[data.field],
                type: data.operator,
                value: (data.inclusive === 'exclude' ? '~' : '') + data.filter_value
              }
              const includesFilter = vueComponent.allFilters.some(obj => {
                // const sanitizedType = filter.type === 'Containing' ? 'like' : filter.type
                let inEqual = false
                if (filter.type === 'in') {
                  inEqual = filter.value === obj.value[0]
                }
                return obj.field === filter.field && obj.type === filter.type && (inEqual || obj.value === filter.value)
              })
              if (includesFilter) {
                vueComponent.removeFilter(filter)
              }
            }
            // cell._cell.row.delete()
            const rowCount = cell.getTable().getDataCount()
            const row = cell.getRow()
            if (rowCount === 1) {
              row.getCell('inclusive').setValue('include')
              row.getCell('filter_value').setValue('')
              row.getCell('field').setValue(vueComponent.defaultField)
            } else {
              row.delete()
            }
          }
        },
        {
          title: 'Include/Exclude',
          field: 'inclusive',
          editor: 'select',
          width: 60,
          editorParams: {
            values: ['include', 'exclude'],
            defaultValue: 'include'
          }
        },
        {
          title: 'Field',
          field: 'field',
          resizable: true,
          headerSort: false,
          minWidth: 100,
          width: 160,
          editor: 'select',
          mutator: function (value, data, type, params, component) {
            return vueComponent.fieldLabels[value]
          },
          editorParams: vueComponent._editorParams('field', vueComponent),
          cellEdited: vueComponent._cellEdited
        },
        {
          title: 'Operator',
          field: 'operator',
          resizable: true,
          headerSort: false,
          hozAlign: 'center',
          minWidth: 100,
          width: 160,
          editor: 'select',
          editorParams: vueComponent._editorParams('operator', vueComponent),
          cellEdited: vueComponent._cellEdited,
          formatter: 'lookup',
          formatterParams: (cell) => {
            const field = cell.getRow().getCell('field')
            let lessThan = 'Less Than'
            let greaterThan = 'Greater Than'
            if (field && field.getValue() === 'Target Date') {
              lessThan = 'Before'
              greaterThan = 'After'
            }
            return {
              'in': 'Equal to',
              '=': 'Equal to',
              '!=': 'Not Equal',
              '>': greaterThan,
              '<': lessThan,
              '>=': 'Greater Than/Equal to',
              '<=': 'Less Than/Equal to'
            }
          }
        },
        {
          title: 'Value',
          field: 'filter_value',
          resizable: true,
          headerSort: false,
          minWidth: 200,
          editor: 'autocomplete',
          editorParams: vueComponent._editorParams('filter_value', vueComponent),
          cellEdited: vueComponent._cellEdited,
          cellEditing: function (cell) {
            vueComponent.$nextTick(() => {
              const selectList = document.getElementsByClassName('tabulator-edit-select-list')  
              Array.from(selectList).forEach((element) => {
                element.setAttribute('private-content', true)
              });
            })
          },
          mutator: function (value, data, type, params, component) {
            return vueComponent.fieldLabels[value] || value
          },
          formatter: function (cell) {
            cell.getElement().setAttribute('private-content', true)
            return cell.getValue()
          }
        }
      ]

    })
  }
}

</script>

<style scoped lang="scss">

  .controls {
    display: flex;
    margin-top: 30px;

    &__icon {
      margin-right: 2px;
      font-size: 15px;
    }

    &__button {
      height: 40px;
      width: 15%;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      border: none;
      outline: none;
      cursor: pointer;

      color: $rfx-dark-march;
      background-color: #fff;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }

      &_add_row {
        width: 100%;
      }

      &_cancel {
        margin-left: auto;
        margin-right: 10px;
      }
    }
  }

  // .tab-container {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  // }

  // .tabs {
  //       display: grid;
  //       width: 50%;
  //       margin: 30px 0;
  //       grid-template-columns: 1fr 1fr 1fr;
  //       border: 1px solid $rfx-light-steel;
  //       border-radius: 4px;
  //       height: 40px;
  //       margin-left: auto;
  //   }

  // .tab {
  //       font-weight: 500;
  //       outline: none;
  //       font-size: 10px;
  //       border: 1px solid $rfx-light-steel;
  //       color: $rfx-dark-march;
  //       margin: 0;
  //       cursor: pointer;
  //       transition: box-shadow .3s;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //       background-color: #fff;
  //       text-decoration: none;
  //       &:hover{
  //           /* box-shadow: 0 0 11px 5px rgba(33,33,33,.2); */
  //           background-color: rgba(1, 22, 39, 0.1);
  //           opacity: 1;
  //       }
  //   }

</style>
